/**
 * The current list of supported transportation emojis
 */
export const transportationEmojis = [
  {
    emoji: '🚂',
    skin_tone_support: false,
    name: 'locomotive',
    slug: 'locomotive',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚅',
    skin_tone_support: false,
    name: 'bullet train',
    slug: 'bullet_train',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚆',
    skin_tone_support: false,
    name: 'train',
    slug: 'train',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚊',
    skin_tone_support: false,
    name: 'tram',
    slug: 'tram',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚌',
    skin_tone_support: false,
    name: 'bus',
    slug: 'bus',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚍',
    skin_tone_support: false,
    name: 'oncoming bus',
    slug: 'oncoming_bus',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '🚎',
    skin_tone_support: false,
    name: 'trolleybus',
    slug: 'trolleybus',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚐',
    skin_tone_support: false,
    name: 'minibus',
    slug: 'minibus',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚕',
    skin_tone_support: false,
    name: 'taxi',
    slug: 'taxi',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚖',
    skin_tone_support: false,
    name: 'oncoming taxi',
    slug: 'oncoming_taxi',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },
  {
    emoji: '🚗',
    skin_tone_support: false,
    name: 'automobile',
    slug: 'automobile',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚘',
    skin_tone_support: false,
    name: 'oncoming automobile',
    slug: 'oncoming_automobile',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '🚙',
    skin_tone_support: false,
    name: 'sport utility vehicle',
    slug: 'sport_utility_vehicle',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🛻',
    skin_tone_support: false,
    name: 'pickup truck',
    slug: 'pickup_truck',
    unicode_version: '13.0',
    emoji_version: '13.0',
  },
  {
    emoji: '🏍️',
    skin_tone_support: false,
    name: 'motorcycle',
    slug: 'motorcycle',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '🛵',
    skin_tone_support: false,
    name: 'motor scooter',
    slug: 'motor_scooter',
    unicode_version: '3.0',
    emoji_version: '3.0',
  },
  {
    emoji: '🚲',
    skin_tone_support: false,
    name: 'bicycle',
    slug: 'bicycle',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🛴',
    skin_tone_support: false,
    name: 'kick scooter',
    slug: 'kick_scooter',
    unicode_version: '3.0',
    emoji_version: '3.0',
  },
  {
    emoji: '⛵',
    skin_tone_support: false,
    name: 'sailboat',
    slug: 'sailboat',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🛶',
    skin_tone_support: false,
    name: 'canoe',
    slug: 'canoe',
    unicode_version: '3.0',
    emoji_version: '3.0',
  },
  {
    emoji: '🚤',
    skin_tone_support: false,
    name: 'speedboat',
    slug: 'speedboat',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🛳️',
    skin_tone_support: false,
    name: 'passenger ship',
    slug: 'passenger_ship',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '⛴️',
    skin_tone_support: false,
    name: 'ferry',
    slug: 'ferry',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '🛥️',
    skin_tone_support: false,
    name: 'motor boat',
    slug: 'motor_boat',
    unicode_version: '0.7',
    emoji_version: '0.7',
  },
  {
    emoji: '✈️',
    skin_tone_support: false,
    name: 'airplane',
    slug: 'airplane',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚁',
    skin_tone_support: false,
    name: 'helicopter',
    slug: 'helicopter',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },

  {
    emoji: '🏇',
    skin_tone_support: true,
    skin_tone_support_unicode_version: '1.0',
    name: 'horse racing',
    slug: 'horse_racing',
    unicode_version: '1.0',
    emoji_version: '1.0',
  },

  {
    emoji: '🐎',
    skin_tone_support: false,
    name: 'horse',
    slug: 'horse',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚶',
    skin_tone_support: true,
    skin_tone_support_unicode_version: '1.0',
    name: 'person walking',
    slug: 'person_walking',
    unicode_version: '0.6',
    emoji_version: '0.6',
  },
  {
    emoji: '🚶‍➡️',
    skin_tone_support: true,
    skin_tone_support_unicode_version: '15.1',
    name: 'person walking facing right',
    slug: 'person_walking_facing_right',
    unicode_version: '15.1',
    emoji_version: '15.1',
  },
  {
    emoji: '🥾',
    skin_tone_support: false,
    name: 'hiking boot',
    slug: 'hiking_boot',
    unicode_version: '11.0',
    emoji_version: '11.0',
  },
]

type EmojiLocale = 'en' | 'de' | 'fr' | 'pt-br'

/**
 * Emoji translations for multilingual search support
 * Transportation emojis with English, German, French and Portuguese (Brazilian) translations
 */
export const emojiTranslations: Partial<
  Record<string, Record<EmojiLocale, string[]>>
> = {
  '🚂': {
    en: ['locomotive', 'train', 'steam train'],
    de: ['lokomotive', 'dampflok', 'zug', 'dampfzug'],
    fr: ['locomotive', 'train', 'train à vapeur'],
    'pt-br': ['locomotiva', 'trem', 'trem a vapor'],
  },
  '🚅': {
    en: ['bullet train', 'high speed train', 'train'],
    de: ['hochgeschwindigkeitszug', 'schnellzug', 'zug', 'ice'],
    fr: ['train à grande vitesse', 'tgv', 'train'],
    'pt-br': ['trem-bala', 'trem de alta velocidade', 'trem'],
  },
  '🚆': {
    en: ['train', 'railway'],
    de: ['zug', 'eisenbahn', 'bahn'],
    fr: ['train', 'chemin de fer'],
    'pt-br': ['trem', 'ferrovia'],
  },
  '🚊': {
    en: ['tram', 'streetcar', 'trolley'],
    de: ['straßenbahn', 'tram', 'straßenbahn'],
    fr: ['tramway', 'tram'],
    'pt-br': ['bonde', 'tram', 'veículo leve sobre trilhos'],
  },
  '🚌': {
    en: ['bus', 'coach'],
    de: ['bus', 'autobus', 'omnibus'],
    fr: ['bus', 'autobus', 'car'],
    'pt-br': ['ônibus', 'autocarro'],
  },
  '🚍': {
    en: ['oncoming bus', 'bus'],
    de: ['entgegenkommender bus', 'bus', 'autobus'],
    fr: ['bus qui arrive', 'bus'],
    'pt-br': ['ônibus se aproximando', 'ônibus'],
  },
  '🚎': {
    en: ['trolleybus', 'trolley'],
    de: ['oberleitungsbus', 'obus', 'trolleybus'],
    fr: ['trolleybus'],
    'pt-br': ['trólebus'],
  },
  '🚐': {
    en: ['minibus', 'van', 'microbus'],
    de: ['kleinbus', 'minibus', 'van', 'transporter'],
    fr: ['minibus', 'fourgonnette', 'van'],
    'pt-br': ['micro-ônibus', 'van', 'minibus'],
  },
  '🚕': {
    en: ['taxi', 'cab'],
    de: ['taxi', 'taxe', 'droschke'],
    fr: ['taxi'],
    'pt-br': ['táxi'],
  },
  '🚖': {
    en: ['oncoming taxi', 'taxi', 'cab'],
    de: ['entgegenkommendes taxi', 'taxi', 'taxe'],
    fr: ['taxi qui arrive', 'taxi'],
    'pt-br': ['táxi se aproximando', 'táxi'],
  },
  '🚗': {
    en: ['automobile', 'car', 'vehicle'],
    de: ['auto', 'automobil', 'pkw', 'wagen', 'fahrzeug'],
    fr: ['automobile', 'voiture', 'véhicule'],
    'pt-br': ['automóvel', 'carro', 'veículo'],
  },
  '🚘': {
    en: ['oncoming automobile', 'car', 'vehicle'],
    de: ['entgegenkommendes auto', 'auto', 'pkw', 'wagen'],
    fr: ['voiture qui arrive', 'automobile'],
    'pt-br': ['carro se aproximando', 'automóvel'],
  },
  '🚙': {
    en: ['sport utility vehicle', 'suv', 'car'],
    de: ['geländewagen', 'suv', 'auto', 'offroader'],
    fr: ['véhicule utilitaire sport', 'suv', 'tout-terrain'],
    'pt-br': ['veículo utilitário esportivo', 'suv', 'utilitário esportivo'],
  },
  '🛻': {
    en: ['pickup truck', 'truck', 'pickup'],
    de: ['pickup', 'pritschenwagen', 'lastwagen', 'truck'],
    fr: ['pick-up', 'camionnette'],
    'pt-br': ['picape', 'caminhonete', 'pickup'],
  },
  '🏍️': {
    en: ['motorcycle', 'motorbike', 'bike'],
    de: ['motorrad', 'krad', 'maschine', 'bike'],
    fr: ['moto', 'motocyclette'],
    'pt-br': ['motocicleta', 'moto', 'bike'],
  },
  '🛵': {
    en: ['motor scooter', 'scooter', 'vespa'],
    de: ['motorroller', 'roller', 'vespa', 'scooter'],
    fr: ['scooter', 'vélomoteur'],
    'pt-br': ['scooter', 'lambreta', 'vespa'],
  },
  '🚲': {
    en: ['bicycle', 'bike', 'cycle'],
    de: ['fahrrad', 'rad', 'velo', 'bike', 'drahtesel'],
    fr: ['vélo', 'bicyclette', 'cycle'],
    'pt-br': ['bicicleta', 'bike', 'magrela'],
  },
  '🛴': {
    en: ['kick scooter', 'scooter'],
    de: ['tretroller', 'roller', 'scooter', 'cityroller'],
    fr: ['trottinette'],
    'pt-br': ['patinete', 'scooter'],
  },
  '⛵': {
    en: ['sailboat', 'sailing boat', 'yacht', 'boat'],
    de: ['segelboot', 'segler', 'yacht', 'boot', 'segelschiff'],
    fr: ['voilier', 'bateau à voile', 'yacht'],
    'pt-br': ['veleiro', 'barco à vela', 'iate'],
  },
  '🛶': {
    en: ['canoe', 'kayak', 'boat'],
    de: ['kanu', 'kajak', 'boot', 'paddelboot'],
    fr: ['canoë', 'kayak', 'pirogue'],
    'pt-br': ['canoa', 'caiaque', 'barco'],
  },
  '🚤': {
    en: ['speedboat', 'motorboat', 'boat'],
    de: ['schnellboot', 'motorboot', 'boot', 'rennboot'],
    fr: ['hors-bord', 'bateau rapide', 'vedette'],
    'pt-br': ['lancha', 'barco rápido', 'speedboat'],
  },
  '🛳️': {
    en: ['passenger ship', 'ship', 'cruise ship'],
    de: ['passagierschiff', 'schiff', 'kreuzfahrtschiff', 'dampfer'],
    fr: ['navire de passagers', 'paquebot', 'navire de croisière'],
    'pt-br': ['navio de passageiros', 'navio', 'navio de cruzeiro'],
  },
  '⛴️': {
    en: ['ferry', 'boat', 'ship'],
    de: ['fähre', 'boot', 'schiff', 'autofähre'],
    fr: ['ferry', 'bac', 'traversier'],
    'pt-br': ['balsa', 'ferry', 'ferryboat'],
  },
  '🛥️': {
    en: ['motor boat', 'motorboat', 'boat'],
    de: ['motorboot', 'boot', 'yacht'],
    fr: ['bateau à moteur', 'yacht'],
    'pt-br': ['barco a motor', 'iate', 'lancha'],
  },
  '✈️': {
    en: ['airplane', 'plane', 'aircraft', 'flight'],
    de: ['flugzeug', 'flieger', 'maschine', 'jet', 'aircraft'],
    fr: ['avion', 'aéronef', 'vol'],
    'pt-br': ['avião', 'aeronave', 'voo'],
  },
  '🚁': {
    en: ['helicopter', 'chopper', 'heli'],
    de: ['hubschrauber', 'heli', 'chopper', 'helikopter'],
    fr: ['hélicoptère', 'héli'],
    'pt-br': ['helicóptero', 'héli'],
  },
  '🏇': {
    en: ['horse racing', 'jockey', 'racing', 'equestrian'],
    de: ['pferderennen', 'reiten', 'reitsport'],
    fr: ['course de chevaux', 'équitation', 'hippisme'],
    'pt-br': ['corrida de cavalos', 'jóquei', 'equitação', 'hipismo'],
  },
  '🐎': {
    en: ['horse', 'stallion', 'mare', 'pony', 'equine'],
    de: ['pferd', 'hengst', 'stute', 'pony', 'ross'],
    fr: ['cheval', 'étalon', 'jument', 'poney', 'équidé'],
    'pt-br': ['cavalo', 'garanhão', 'égua', 'pônei', 'equino'],
  },
  '🚶': {
    en: ['person walking', 'walking', 'pedestrian', 'walk'],
    de: ['gehender mensch', 'gehen', 'laufen', 'fußgänger', 'spazieren'],
    fr: ['personne qui marche', 'marche', 'piéton', 'marcher'],
    'pt-br': [
      'pessoa caminhando',
      'caminhada',
      'pedestrianismo',
      'caminhar',
      'andar',
    ],
  },
  '🚶‍➡️': {
    en: ['person walking facing right', 'walking right', 'pedestrian right'],
    de: [
      'gehender mensch nach rechts',
      'gehen nach rechts',
      'fußgänger rechts',
    ],
    fr: ['personne qui marche vers la droite', 'marche à droite'],
    'pt-br': [
      'pessoa caminhando para direita',
      'caminhada direita',
      'andar direita',
    ],
  },
  '🥾': {
    en: ['hiking boot', 'boot', 'hiking', 'trekking', 'outdoor'],
    de: [
      'wanderstiefel',
      'stiefel',
      'wandern',
      'trekking',
      'outdoor',
      'bergstiefel',
    ],
    fr: ['chaussure de randonnée', 'botte', 'randonnée', 'trekking', 'outdoor'],
    'pt-br': [
      'bota de caminhada',
      'bota',
      'trilha',
      'trekking',
      'outdoor',
      'caminhada',
    ],
  },
}

/**
 * Helper function to get translations for a specific language
 * If the emoji does not exist, it returns an empty array
 * If the language does not exist, it returns the English translations
 *
 * @param emoji the emoji to get translations for
 * @param locale the locale to get translations for (e.g. 'en', 'de', 'fr', 'pt-br')
 * @returns array of translations in the specified language
 */
export function getEmojiTranslations(emoji: string, locale: string): string[] {
  const translations = emojiTranslations[emoji]
  if (!translations) {
    return []
  }

  return translations[locale as keyof typeof translations] || translations.en
}

export const emojiSuggestionsByTransportationType = {
  driving: ['🚗', '🚘', '🚙', '🛻', '🚐', '🚕', '🚖', '🏍️', '🛵'],
  transit: ['🚂', '🚅', '🚆', '🚊', '🚌', '🚍', '🚎', '🚐'],
  flight: ['✈️', '🚁'],
  cycling: ['🚲', '🛴'],
  walking: ['🚶', '🚶‍➡️', '🥾', '🏇', '🐎'],
  boat: ['⛵', '🛶', '🚤', '🛳️', '⛴️', '🛥️'],
}
